import { render, staticRenderFns } from "./ModuleClientProduct.vue?vue&type=template&id=746cd962&scoped=true&lang=pug&"
import script from "./ModuleClientProduct.vue?vue&type=script&lang=js&"
export * from "./ModuleClientProduct.vue?vue&type=script&lang=js&"
import style0 from "./ModuleClientProduct.vue?vue&type=style&index=0&id=746cd962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746cd962",
  null
  
)

export default component.exports